import getAccount from './getAccount'
import createAccount from './createAccount'
import checkVelaeasyLogin from './checkVelaeasyLogin'
import updateAccountInfo from './updateAccountInfo'
import getShopAuthToken from './getShopAuthToken'
import createShopByMultiVelaeasyLogin from './createShopByMultiVelaeasyLogin'
import logout from './logout'

export const getAccountAPI = getAccount
export const createAccountAPI = createAccount
export const checkVelaeasyLoginAPI = checkVelaeasyLogin
export const updateAccountInfoAPI = updateAccountInfo
export const getShopAuthTokenAPI = getShopAuthToken
export const createShopByMultiVelaeasyLoginAPI = createShopByMultiVelaeasyLogin
export const logoutAPI = logout
